__turbopack_context__.v({
  "component": "style-module-scss-module__fsWDGG__component",
  "list-price": "style-module-scss-module__fsWDGG__list-price",
  "list-price-only": "style-module-scss-module__fsWDGG__list-price-only",
  "price": "style-module-scss-module__fsWDGG__price",
  "sold-wrapper": "style-module-scss-module__fsWDGG__sold-wrapper",
});
